/** @jsx jsx */
import { jsx, css } from '@emotion/core'

const Color = css`
  width: inherit;
  height: auto;
  .fill {
    fill: #eee;
  }
`

export default function MatchupIco() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" css={Color}>
      <g id="그룹_6955" data-name="그룹 6955" transform="translate(15794 12303)">
        <rect id="사각형_6570" data-name="사각형 6570" width="22" height="22" transform="translate(-15794 -12303)" fill="#1993ff" opacity="0"/>
        <g id="그룹_6953" data-name="그룹 6953" transform="translate(0.5 -0.001)">
          <path id="패스_6333" className="fill" data-name="패스 6333" d="M617.333,631.667h-19a1,1,0,0,1-1-1v-16a1,1,0,0,1,1-1h19a1,1,0,0,1,1,1v16A1,1,0,0,1,617.333,631.667Zm-18.8-1.2h18.6v-15.6h-18.6Z" transform="translate(-16391.332 -12914.666)"/>
          <path id="패스_6334" className="fill" data-name="패스 6334" d="M598.08,626.257h-.6v-7.2h.6a3.6,3.6,0,1,1,0,7.2Zm.6-5.924v4.648a2.4,2.4,0,0,0,0-4.648Z" transform="translate(-16391.479 -12914.656)"/>
          <path id="패스_6335" className="fill" data-name="패스 6335" d="M618.184,626.267h-.6a3.6,3.6,0,1,1,0-7.2h.6Zm-1.2-5.924a2.4,2.4,0,0,0,0,4.648Z" transform="translate(-16391.184 -12914.666)"/>
          <path id="패스_6336" className="fill" data-name="패스 6336" d="M607.833,626.756a4.1,4.1,0,1,1,4.1-4.1A4.1,4.1,0,0,1,607.833,626.756Zm0-7a2.9,2.9,0,1,0,2.9,2.9A2.9,2.9,0,0,0,607.833,619.756Z" transform="translate(-16391.332 -12914.655)"/>
          <rect id="사각형_6575" className="fill" data-name="사각형 6575" width="1.2" height="17.913" transform="translate(-15784.098 -12300.912)"/>
        </g>
      </g>
    </svg>
  )
}
